import { useState, useEffect, useRef } from 'react';

const FULL = 'Marco Tiberio Ferri Marini';

const BURSTS = [4, 4, 6, 4];
const JUMPS = [-2, -2, -2];

function sleep(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

function firstKeyDelay() {
  return 220 + Math.random() * 180;
}

function repeatDelay(i: number) {
  const ramp = Math.max(52, 95 - i * 9);
  if (Math.random() < 0.09) return 160 + Math.random() * 140;
  return ramp + Math.random() * 28 - 8;
}

export function Hero() {
  const [text, setText] = useState(FULL);
  const [cursorPos, setCursorPos] = useState(FULL.length);
  const [busy, setBusy] = useState(false);
  const textRef = useRef(FULL);
  const posRef = useRef(FULL.length);

  useEffect(() => {
    const signal = { cancelled: false };

    const sync = (nextText: string, nextPos: number) => {
      textRef.current = nextText;
      posRef.current = nextPos;
      setText(nextText);
      setCursorPos(nextPos);
    };

    const run = async () => {
      await sleep(1600);
      if (signal.cancelled) return;

      for (let b = 0; b < BURSTS.length; b++) {
        if (signal.cancelled) return;

        setBusy(true);
        await sleep(firstKeyDelay());

        const count = BURSTS[b];
        for (let i = 0; i < count; i++) {
          if (signal.cancelled) return;
          const t = textRef.current;
          const p = posRef.current;
          sync(t.slice(0, p - 1) + t.slice(p), p - 1);
          await sleep(repeatDelay(i));
        }

        setBusy(false);
        if (b >= JUMPS.length) break;

        await sleep(260 + Math.random() * 180);
        if (signal.cancelled) return;
        sync(textRef.current, posRef.current + JUMPS[b]);
        await sleep(340 + Math.random() * 220);
      }

      if (signal.cancelled) return;
      setBusy(false);
      await sleep(2400);
      if (signal.cancelled) return;
      sync(textRef.current, textRef.current.length);
    };

    run();
    return () => { signal.cancelled = true; };
  }, []);

  return (
    <section style={{ 
      padding: '3rem 1.5rem 2rem 1.5rem', 
      maxWidth: '42rem', 
      margin: '0 auto' 
    }}>
      <h1 style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontWeight: 500,
        fontSize: 'clamp(2rem, 5vw, 3.25rem)',
        lineHeight: 1.15,
        letterSpacing: '-0.03em',
        margin: '0 0 1rem 0',
        color: 'var(--charcoal)',
      }}>
        {text.slice(0, cursorPos)}
        <span
          className={busy ? 'editing-cursor' : 'cursor-blink'}
          style={{ fontWeight: 300 }}
        >|</span>
        {text.slice(cursorPos)}
      </h1>

      <p style={{
        fontFamily: "'Crimson Text', Georgia, serif",
        fontSize: '1.125rem',
        lineHeight: 1.75,
        color: 'var(--muted)',
        maxWidth: '32rem',
        margin: '0 0 1.5rem 0',
        fontStyle: 'italic'
      }}>
        Software/ML engineer. I build embedding pipelines, anomaly detectors,
        and the occasional full-stack product.
      </p>

      <p style={{
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: '0.75rem',
        color: 'var(--muted)',
        margin: 0
      }}>
        roma, italy.
      </p>

    </section>
  );
}
